// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — mode-input.classic.js, новая — mode-input.cp.js
import { isCp } from 'libs/design';
import * as classic from './mode-input.classic';
import * as cp from './mode-input.cp';

export const ModeInput = isCp ? cp.ModeInput : classic.ModeInput;
